export const GET_TASK = "GET_TASK";
export const GET_TASK_HISTORY = "GET_TASK_HISTORY";
export const CLAIM_REWARD = "CLAIM_REWARD";
export const GET_HOST_LIVE_HISTORY = "GET_HOST_LIVE_HISTORY";
